import { render, staticRenderFns } from "./TheTabMenu.vue?vue&type=template&id=dbba6cb2"
import script from "./TheTabMenu.vue?vue&type=script&lang=js"
export * from "./TheTabMenu.vue?vue&type=script&lang=js"
import style0 from "./TheTabMenu.vue?vue&type=style&index=0&id=dbba6cb2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports